import { ImageOffIcon } from 'lucide-react';

interface ChangelogMediaCellProps {
  pathUri?: string | null;
}

/** Miniature inerte partagée par les colonnes « média » des tables changelog. */
export function ChangelogMediaCell({ pathUri }: ChangelogMediaCellProps) {
  if (!pathUri) {
    return (
      <div className="flex size-10 items-center justify-center rounded-md border bg-muted text-muted-foreground">
        <ImageOffIcon className="size-4" />
      </div>
    );
  }

  return (
    <img src={pathUri} alt="" loading="lazy" className="size-10 rounded-md border object-cover" />
  );
}
